import React from 'react';
import { Text, TouchableOpacity, StyleSheet } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useI18n } from '../../i18n';
import { fontWeights } from '../../styles/typographyTokens';
import { openAgapellaPaywall } from '../../services/agapellaGate';

const SOLAR = '#E98245';

/**
 * CORE-1781 — кнопка под репликой Агапеллы «бесплатные сообщения закончились»
 * (CORE-1771, маркер `agapella_subscription_required`).
 *
 * Открывает общее окно «Входит в Agapēlla» (CORE-1776): пробный доступ,
 * оплата или стор — по тем же правилам, что у эфиров. Сообщение человека к
 * этому моменту уже доставлено, повторять нечего. Одна кнопка на веб-тред,
 * виджет и нативный чат, как у `ReflectionOfferButton`.
 */
export function AgapellaSubscriptionOfferButton({ messageId }: { messageId: string }) {
  const { t } = useI18n('chats');
  const label = t('agapellaSubscriptionOffer.button');
  return (
    <TouchableOpacity
      testID={`agapella-subscription-offer-${messageId}`}
      accessibilityRole="button"
      accessibilityLabel={label}
      activeOpacity={0.85}
      onPress={() => openAgapellaPaywall({ kind: 'ai', surface: 'ai_chat' })}
      style={styles.button}
    >
      <Ionicons name="sparkles-outline" size={16} color={SOLAR} />
      <Text style={styles.label}>{label}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', gap: 6,
    borderWidth: 1, borderColor: SOLAR, borderRadius: 999,
    paddingHorizontal: 14, paddingVertical: 8,
  },
  label: { color: SOLAR, fontSize: 13, fontWeight: fontWeights.semibold },
});
